// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1lsSk","notes":"Notes_notes__1SZ1K"};